import { lazy, Suspense, useState, useEffect, useRef } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";

// Lazy loaded components
const LogosSection = lazy(() => import("@/components/LogosSection"));
const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const AboutSection = lazy(() => import("@/components/AboutSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const CTASection = lazy(() => import("@/components/CTASection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const Footer = lazy(() => import("@/components/Footer"));

const LazyLoad = ({ children, placeholderHeight = "200px" }: { children: React.ReactNode, placeholderHeight?: string }) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "400px" } // Carrega 400px antes de entrar na tela
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef}>
      {isVisible ? (
        <Suspense fallback={<div style={{ height: placeholderHeight }} />}>
          {children}
        </Suspense>
      ) : (
        <div style={{ height: placeholderHeight }} />
      )}
    </div>
  );
};

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        
        <LazyLoad placeholderHeight="100px">
          <LogosSection />
        </LazyLoad>
        
        <div id="servicos" className="scroll-mt-24">
          <div id="seguros" className="scroll-mt-24">
            <div id="consorcios" className="scroll-mt-24">
              <div id="planos-de-saude" className="scroll-mt-24">
                <div id="planos-odontologicos" className="scroll-mt-24">
                  <LazyLoad placeholderHeight="600px">
                    <ServicesSection />
                  </LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div id="sobre" className="scroll-mt-24">
          <LazyLoad placeholderHeight="400px">
            <AboutSection />
          </LazyLoad>
        </div>
        
        <div id="faq" className="scroll-mt-24">
          <LazyLoad placeholderHeight="400px">
            <FAQSection />
          </LazyLoad>
        </div>
        
        <LazyLoad placeholderHeight="300px">
          <CTASection />
        </LazyLoad>
        
        <div id="contato" className="scroll-mt-24">
          <LazyLoad placeholderHeight="500px">
            <ContactSection />
          </LazyLoad>
        </div>
      </main>
      
      <LazyLoad placeholderHeight="300px">
        <Footer />
      </LazyLoad>
    </div>
  );
};

export default Index;
